//Models
PJQ.models.dailyReports.Expense = PJQ.models.BaseModel.extend({
	idAttribute: 'expenseId',
	notifyName: 'Expense',
	endpoint: function () {
		let params = null;
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'dailyReports',
				value: this.get('dailyReportId')
			},
			{
				endpoint: 'expenses',
				value: this.id
			}
		], params);
	},
	afterInit: function(){
		this.on('change:group', _.bind(function(){
			let newGroup = this.get('group');
			if(newGroup instanceof PJQ.models.groups.Group){
				this.group = newGroup;
			}
			else if(newGroup != null && typeof newGroup === 'object'){
				this.group = new PJQ.models.groups.Group(newGroup);
			}
			else{
				this.group = null;
			}
		}, this));
	},
	parse: function (model) {
		if(model != null){
			this.attachments = new PJQ.collections.dailyReports.ExpenseAttachments(model.attachments);
			this.attachments.on('update', _.bind(function(){
				this.isDirty = true;
			}, this));

			if(model.group != null){
				this.group = new PJQ.models.groups.Group(model.group);
			}
		}
		return model;
	},
	beforeSave: function () {
		this.set('attachments', this.attachments.getChangedModels());
		this.set('group', this.group);
	}
});

PJQ.models.dailyReports.ExpenseAttachment = PJQ.models.files.File.extend({
	idAttribute: 'expenseAttachmentId',
	endpoint: function () {
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'expenses',
				value: this.get('expenseId')
			},
			{
				endpoint: 'attachments',
				value: this.id
			}
		]);
	}
});


//Collections
PJQ.collections.dailyReports.Expenses = PJQ.collections.BaseCollection.extend({
	model: PJQ.models.dailyReports.Expense
});

PJQ.collections.dailyReports.ExpenseAttachments = PJQ.collections.dailyReports.Attachments.extend({
	model: PJQ.models.dailyReports.ExpenseAttachment
});